export function initVideoHoverHome(){
    if (window.innerWidth <= 991) return; // только для больших экранов

    const items: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(".approach-item");

    items.forEach((item) => {
        const videoContainer = item.querySelector<HTMLSpanElement>(".approach-item__video");
        if (!videoContainer) return;

        const videoSrc = videoContainer.dataset.video;
        if (!videoSrc) return;

        let videoEl: HTMLVideoElement | null = null;

        item.addEventListener("mouseenter", () => {
            if (!videoEl) {
                videoEl = document.createElement("video");
                videoEl.src = videoSrc;
                videoEl.autoplay = true;
                videoEl.muted = true; // чтобы autoplay работал в браузерах
                videoEl.playsInline = true;
                videoEl.loop = true; // можно заменить на true, если нужно зацикливание

                // стили подгонки
                videoEl.style.width = "100%";
                videoEl.style.height = "100%";
                videoEl.style.objectFit = "cover";

                videoContainer.appendChild(videoEl);
            } else {
                void videoEl.play();
            }
        });

        item.addEventListener("mouseleave", () => {
            if (videoEl) {
                videoEl.pause();
            }
        });
    });
}